import React, { useEffect, useState } from "react";
import { Form, Offcanvas } from "react-bootstrap";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import { studyLevelFormManagementServices } from "../../../../APIServices/studyLevelFormManagementServices";

const FormReview = ({
  formId,
  getStudyLevelFormFieldsByVersion,
  Show,
  Hide,
  Title,
  setDVQualityCheck,
  setDBPQualityCheck,
  getStudyLevelForm,
}) => {
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  let { studyId } = useParams();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const digitalSignatureStudyLevelForm = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Signature provied to the Form!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, sign it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.formId = formId;
        userData.studyId = studyId;
        userData.userId = userId;
        userData.password = password;
        userData.mode = StudyMode;
        let data =
          await studyLevelFormManagementServices.digitalSignatureStudyLevelForm(
            userData
          );
        if (data?.statusCode === 200) {
          if (StudyMode === "DBP Mode") {
            setDBPQualityCheck("yes");
          }
          if (StudyMode === "DV Mode") {
            setDVQualityCheck("yes");
          }
          getStudyLevelForm();
          getStudyLevelFormFieldsByVersion();
          Hide();
          setUserId("");
          setPassword("");
        }
      }
    });
  };
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Group
            style={{ textAlign: "justify", fontSize: 13 }}
            className="mb-3"
          >
            <p className="m-0 bg-success-subtle p-2">
              You are required to provide a signature for this activity in order
              to fully complete it. This records that you are signing off theat
              you have taken, and completed this online review activity. This
              will resilt in the completion record being recorded in your review
              history.
            </p>
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              UserId{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => setUserId(e.target.value)}
              value={userId}
              className="br3"
              placeholder="UserId"
              type="text"
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Password{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => setPassword(e.target.value)}
              value={password}
              className="br3"
              placeholder="Password"
              type="password"
            />
          </Form.Group>
        </Offcanvas.Body>
        <div className="p-2 bg-light border-top shadow-sm hstack justify-content-end gap-2">
          <button
            disabled={!userId || !password}
            className="updateProfile"
            onClick={(e) => digitalSignatureStudyLevelForm(e)}
          >
            Sign Now
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default FormReview;
